"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MultiSelectManager_eventEngine, _MultiSelectManager_logger, _MultiSelectManager_tree, _MultiSelectManager_boxSelectionKey, _MultiSelectManager_deselectOnEmpty, _MultiSelectManager_filter, _MultiSelectManager_groupInteractionEffectToken, _MultiSelectManager_groupedNodes, _MultiSelectManager_insertionKey, _MultiSelectManager_interactionEffectTokens, _MultiSelectManager_keyPressed, _MultiSelectManager_maximumNodes, _MultiSelectManager_minimumNodes, _MultiSelectManager_nodes, _MultiSelectManager_removalKey;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectManager = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const IInteractionEngine_1 = require("../../interfaces/IInteractionEngine");
const AbstractInteractionManager_1 = require("../AbstractInteractionManager");
const InteractionManagerUtils_1 = require("../utils/InteractionManagerUtils");
/* eslint-disable @typescript-eslint/no-unused-vars */
class MultiSelectManager extends AbstractInteractionManager_1.AbstractInteractionManager {
    constructor(id, interactionEffect, minimumNodes, maximumNodes) {
        super(id, interactionEffect);
        _MultiSelectManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _MultiSelectManager_logger.set(this, viewer_shared_services_1.Logger.instance);
        _MultiSelectManager_tree.set(this, viewer_shared_node_tree_1.Tree.instance);
        _MultiSelectManager_boxSelectionKey.set(this, "Alt");
        _MultiSelectManager_deselectOnEmpty.set(this, false);
        _MultiSelectManager_filter.set(this, InteractionManagerUtils_1.InteractionManagerUtils.createInteractionFilter("select", this.id, [
            IInteractionEngine_1.INTERACTION_STATE.DOWN,
            IInteractionEngine_1.INTERACTION_STATE.END,
        ]));
        _MultiSelectManager_groupInteractionEffectToken.set(this, []);
        _MultiSelectManager_groupedNodes.set(this, []);
        _MultiSelectManager_insertionKey.set(this, "Shift");
        _MultiSelectManager_interactionEffectTokens.set(this, []);
        _MultiSelectManager_keyPressed.set(this, {
            insertion: false,
            removal: false,
            boxSelection: false,
        });
        _MultiSelectManager_maximumNodes.set(this, Infinity);
        _MultiSelectManager_minimumNodes.set(this, 0);
        _MultiSelectManager_nodes.set(this, []);
        _MultiSelectManager_removalKey.set(this, "Control");
        if (minimumNodes)
            __classPrivateFieldSet(this, _MultiSelectManager_minimumNodes, minimumNodes, "f");
        if (maximumNodes)
            __classPrivateFieldSet(this, _MultiSelectManager_maximumNodes, maximumNodes, "f");
    }
    get boxSelectionActive() {
        return __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").boxSelection;
    }
    get boxSelectionKey() {
        return __classPrivateFieldGet(this, _MultiSelectManager_boxSelectionKey, "f");
    }
    set boxSelectionKey(value) {
        __classPrivateFieldSet(this, _MultiSelectManager_boxSelectionKey, value, "f");
    }
    get deselectOnEmpty() {
        return __classPrivateFieldGet(this, _MultiSelectManager_deselectOnEmpty, "f");
    }
    set deselectOnEmpty(value) {
        __classPrivateFieldSet(this, _MultiSelectManager_deselectOnEmpty, value, "f");
    }
    get filter() {
        return __classPrivateFieldGet(this, _MultiSelectManager_filter, "f");
    }
    get insertionActive() {
        return __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").insertion;
    }
    get insertionKey() {
        return __classPrivateFieldGet(this, _MultiSelectManager_insertionKey, "f");
    }
    set insertionKey(value) {
        __classPrivateFieldSet(this, _MultiSelectManager_insertionKey, value, "f");
    }
    get maximumNodes() {
        return __classPrivateFieldGet(this, _MultiSelectManager_maximumNodes, "f");
    }
    set maximumNodes(value) {
        __classPrivateFieldSet(this, _MultiSelectManager_maximumNodes, value, "f");
    }
    get minimumNodes() {
        return __classPrivateFieldGet(this, _MultiSelectManager_minimumNodes, "f");
    }
    set minimumNodes(value) {
        __classPrivateFieldSet(this, _MultiSelectManager_minimumNodes, value, "f");
    }
    get removalActive() {
        return __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").removal;
    }
    get removalKey() {
        return __classPrivateFieldGet(this, _MultiSelectManager_removalKey, "f");
    }
    set removalKey(value) {
        __classPrivateFieldSet(this, _MultiSelectManager_removalKey, value, "f");
    }
    add(viewport) {
        this.viewport = viewport;
    }
    /**
     * Deselect a specific node.
     *
     * @param node
     */
    deselect(node) {
        if (__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").includes(node))
            this.deactivateNode(node);
        this.emitSelectionEvents();
    }
    /**
     * Deselect all nodes.
     */
    deselectAll() {
        while (__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length > 0)
            this.deactivateNode(__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f")[0]);
        this.emitSelectionEvents();
    }
    onDown(event, ray, intersection) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _MultiSelectManager_logger, "f")))
            return;
        const intersections = intersection.filter((i) => this.filter(IInteractionEngine_1.INTERACTION_STATE.DOWN)(i.node));
        // create a list that replaces all irrelevant intersections with null
        const filteredIntersections = intersections.map((i) => {
            return InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(i.node, true, this.id, "select") && i.type === "RayTracingIntersection"
                ? i
                : null;
        });
        const firstIntersection = filteredIntersections.length > 0 ? filteredIntersections[0] : null;
        this.manageIntersection(event, firstIntersection, ray);
    }
    onEnd(event, ray, intersection, endState) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _MultiSelectManager_logger, "f")))
            return;
        const intersections = intersection.filter((i) => this.filter(IInteractionEngine_1.INTERACTION_STATE.END)(i.node));
        // create a list that replaces all irrelevant intersections with null
        const filteredIntersections = intersections.map((i) => {
            return InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(i.node, true, this.id, "select") && i.type === "BoxSelectionIntersection"
                ? i
                : null;
        });
        for (let i = 0; i < filteredIntersections.length; i++) {
            const intersection = filteredIntersections[i];
            this.manageIntersection(event, intersection, ray);
        }
        this.emitSelectionEvents(event);
    }
    onKeyDown(event, pointerInCanvas) {
        if (event.key === __classPrivateFieldGet(this, _MultiSelectManager_insertionKey, "f"))
            __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").insertion = true;
        if (event.key === __classPrivateFieldGet(this, _MultiSelectManager_removalKey, "f"))
            __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").removal = true;
        if (event.key === __classPrivateFieldGet(this, _MultiSelectManager_boxSelectionKey, "f"))
            __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").boxSelection = true;
    }
    onKeyUp(event, pointerInCanvas) {
        if (event.key === __classPrivateFieldGet(this, _MultiSelectManager_insertionKey, "f"))
            __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").insertion = false;
        if (event.key === __classPrivateFieldGet(this, _MultiSelectManager_removalKey, "f"))
            __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").removal = false;
        if (event.key === __classPrivateFieldGet(this, _MultiSelectManager_boxSelectionKey, "f"))
            __classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").boxSelection = false;
    }
    onMove(event, ray, intersection) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _MultiSelectManager_logger, "f")))
            return;
    }
    remove() {
        while (__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length > 0)
            this.deactivateNode(__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f")[0]);
        this.viewport = undefined;
    }
    /**
     * Select a node.
     * The point and distance of the intersection can be freely chosen and are provided in the event callbacks.
     *
     * @param intersection
     */
    select(intersection) {
        var _a;
        if (__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").includes(intersection.node))
            this.deactivateNode(intersection.node);
        this.activateNode(Object.assign(Object.assign({}, intersection), { type: (_a = intersection.type) !== null && _a !== void 0 ? _a : "RayTracingIntersection" }));
        this.emitSelectionEvents();
    }
    /**
     * Utility function to make the node the current active node.
     * Set the according values, apply the effect and emit the event.
     *
     * @param intersection
     * @param event
     * @param ray
     */
    activateNode(intersection, event, ray) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _MultiSelectManager_logger, "f")))
            return;
        __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").push(intersection.node);
        // find the interaction data
        const data = InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(intersection.node, true, this.id, "select");
        if (data)
            data.interactionStates.select = true;
        // find and store all nodes that are within the group
        __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length - 1] = [];
        __classPrivateFieldGet(this, _MultiSelectManager_groupInteractionEffectToken, "f")[__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length - 1] = [];
        if (data && data.groupId)
            __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length - 1] =
                this.gatheredGroupedNodes[data.groupId] || [];
        const { token, groupTokens } = InteractionManagerUtils_1.InteractionManagerUtils.applyInteractionEffects(intersection.node, __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length - 1], this.interactionEffect, this.interactionEffectUtils);
        __classPrivateFieldGet(this, _MultiSelectManager_interactionEffectTokens, "f").push(token);
        __classPrivateFieldGet(this, _MultiSelectManager_groupInteractionEffectToken, "f")[__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length - 1] = groupTokens;
        InteractionManagerUtils_1.InteractionManagerUtils.updateViewport(this.viewport, intersection.node, __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")
            ? __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length - 1]
            : undefined);
        __classPrivateFieldGet(this, _MultiSelectManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.MULTI_SELECT_ON, {
            viewportId: this.viewport.id,
            nodes: __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f"),
            node: intersection.node,
            intersectionPoint: intersection.type === "RayTracingIntersection"
                ? intersection.point
                : undefined,
            ray,
            event,
            manager: this,
            groupedNodes: __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length - 1],
        });
    }
    /**
     * Utility function to make the node inactive.
     * Set the according values, remove the effect and emit the event.
     *
     * @param event
     */
    deactivateNode(node, event) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _MultiSelectManager_logger, "f")))
            return;
        // find the interaction data
        const data = InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(node, true, this.id, "select");
        if (data)
            data.interactionStates.select = false;
        const index = __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").indexOf(node);
        if (index === -1)
            return;
        InteractionManagerUtils_1.InteractionManagerUtils.removeInteractionEffects(node, __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[index], __classPrivateFieldGet(this, _MultiSelectManager_interactionEffectTokens, "f")[index], __classPrivateFieldGet(this, _MultiSelectManager_groupInteractionEffectToken, "f")[index] || [], this.interactionEffectUtils);
        InteractionManagerUtils_1.InteractionManagerUtils.updateViewport(this.viewport, node, __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[index]);
        // Store the grouped nodes before removing from arrays for the event
        const groupedNodes = __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f")[index];
        __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").splice(index, 1);
        __classPrivateFieldGet(this, _MultiSelectManager_interactionEffectTokens, "f").splice(index, 1);
        __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f").splice(index, 1);
        __classPrivateFieldGet(this, _MultiSelectManager_groupInteractionEffectToken, "f").splice(index, 1);
        __classPrivateFieldGet(this, _MultiSelectManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.MULTI_SELECT_OFF, {
            viewportId: this.viewport.id,
            nodes: __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f"),
            node: node,
            event,
            manager: this,
            groupedNodes: groupedNodes,
        });
    }
    emitSelectionEvents(event) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _MultiSelectManager_logger, "f")))
            return;
        if (__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length < __classPrivateFieldGet(this, _MultiSelectManager_minimumNodes, "f")) {
            __classPrivateFieldGet(this, _MultiSelectManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.MULTI_SELECT_MINIMUM_NODES, {
                viewportId: this.viewport.id,
                nodes: __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f"),
                manager: this,
                event,
            });
        }
        if (__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length > __classPrivateFieldGet(this, _MultiSelectManager_maximumNodes, "f")) {
            __classPrivateFieldGet(this, _MultiSelectManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.MULTI_SELECT_MAXIMUM_NODES, {
                viewportId: this.viewport.id,
                nodes: __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f"),
                manager: this,
                event,
            });
        }
    }
    manageIntersection(event, intersection, ray) {
        if (__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").length > 0) {
            let originalNode;
            __classPrivateFieldGet(this, _MultiSelectManager_groupedNodes, "f").forEach((array) => {
                if (intersection && array.includes(intersection.node))
                    originalNode = __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").find((n) => array.includes(n));
            });
            if (intersection &&
                !__classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").includes(intersection.node) &&
                !originalNode) {
                // case other node was clicked, deselect then select (unless removal key is pressed)
                if (!__classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").removal)
                    this.activateNode(intersection, event, ray);
            }
            else if (intersection &&
                __classPrivateFieldGet(this, _MultiSelectManager_nodes, "f").includes(intersection.node)) {
                // case same node was clicked, only deselect (unless insertion key is pressed)
                if (!__classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").insertion)
                    this.deactivateNode(intersection.node, event);
            }
            else if (originalNode) {
                // case it is one of the grouped nodes, deselect (unless insertion key is pressed)
                if (!__classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").insertion)
                    this.deactivateNode(originalNode, event);
            }
        }
        else if (intersection) {
            // easy case, no node select, just select this one (unless removal key is pressed)
            if (!__classPrivateFieldGet(this, _MultiSelectManager_keyPressed, "f").removal)
                this.activateNode(intersection, event, ray);
        }
    }
}
exports.MultiSelectManager = MultiSelectManager;
_MultiSelectManager_eventEngine = new WeakMap(), _MultiSelectManager_logger = new WeakMap(), _MultiSelectManager_tree = new WeakMap(), _MultiSelectManager_boxSelectionKey = new WeakMap(), _MultiSelectManager_deselectOnEmpty = new WeakMap(), _MultiSelectManager_filter = new WeakMap(), _MultiSelectManager_groupInteractionEffectToken = new WeakMap(), _MultiSelectManager_groupedNodes = new WeakMap(), _MultiSelectManager_insertionKey = new WeakMap(), _MultiSelectManager_interactionEffectTokens = new WeakMap(), _MultiSelectManager_keyPressed = new WeakMap(), _MultiSelectManager_maximumNodes = new WeakMap(), _MultiSelectManager_minimumNodes = new WeakMap(), _MultiSelectManager_nodes = new WeakMap(), _MultiSelectManager_removalKey = new WeakMap();
//# sourceMappingURL=MultiSelectManager.js.map